// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
    border-spacing: 0;
}

#asset_table th,
#asset_table td {
    border: 1px solid #ccc;
}

.rotate-right {
    transform: rotate(-90deg);
    /* Rotate to appear "up" */
}

.rotate-down {
    transform: rotate(0deg);
    /* Default position */
}

#asset_table td {
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AssetManager/AllInfoComprehensive/AllInfoExpanded.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["table {\n    border-spacing: 0;\n}\n\n#asset_table th,\n#asset_table td {\n    border: 1px solid #ccc;\n}\n\n.rotate-right {\n    transform: rotate(-90deg);\n    /* Rotate to appear \"up\" */\n}\n\n.rotate-down {\n    transform: rotate(0deg);\n    /* Default position */\n}\n\n#asset_table td {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
